import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchApplicationsFailure,
  fetchApplicationsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchApplications() {
  const url = `${API_BASE_URL}/applications?page=0&size=10`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchApplicationsSuccess(response?.raw?.data || []));
  } else {
    yield put(fetchApplicationsFailure(response.message));
  }
}

function* searchApplications({ payload }) {
  const url = `${API_BASE_URL}/applications/search?pageSize=10&keyword=${payload}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchApplicationsSuccess(response?.raw?.data || []));
  } else {
    yield put(fetchApplicationsFailure(response.message));
  }
}

export function* getApplications() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION,
    fetchApplications
  );
}

export function* onSearchApplication() {
  yield takeEvery(
    ApplicantsActionTypes.SEARCH_APPLICANTS_APPLICATION_START,
    searchApplications
  );
}
